class ProductZoom {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this.name = this.constructor.name
    }

    onInit () {
        if (window.innerWidth > 768) {
            let zoomImage = this._elem.dataset.zoom
            if (zoomImage) {
                this._elem.style.backgroundImage = `url(${zoomImage})`
                this._elem.addEventListener('mousemove', (e) => { this.handleMove(e) })
            }
        }
    }
    handleMove (e) {
        if (window.innerWidth > 768) {
            let parent = document.querySelector('[data-product-images]')
            let left = parent.offsetLeft + 50
            let top = parent.offsetTop

            let width = this._elem.offsetWidth
            let height = this._elem.offsetHeight

            let x = ((e.pageX - left) / width) * 100
            let y = ((e.pageY - top) / height) * 100

            this._elem.style.backgroundPosition = `${x}% ${y}%`
        }
    }
}

export default ProductZoom



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ProductZoom.js